import { InsuranceInput } from '../../lib/types/models/insurance/insurance-input'
import { UpdateInput } from '../../lib/types/utils'
import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export function updateInsurance({ id, ...rest }: UpdateInput<InsuranceInput>) {
  return restApiClient.url(constructApiUrl(API.insurances.update.url, { id })).patch(rest)
}
